/* ══════════════════════════════════════════════════════════
   CC + Co — Scroll Reveal Controller
   IntersectionObserver-based scroll animations
   ══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  const DEFAULTS = {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px',
  };

  function initScrollReveal() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        if (prefersReducedMotion) {
          el.style.transition = 'opacity 0.3s ease';
          el.style.transform = 'none';
        }

        el.classList.add('cc-visible');
        observer.unobserve(el);
      });
    }, DEFAULTS);

    // Observe all reveal elements
    document.querySelectorAll('[data-cc-reveal]').forEach((el) => {
      observer.observe(el);
    });

    // Set stagger indices on children of stagger containers
    document.querySelectorAll('[data-cc-stagger]').forEach((container) => {
      const children = container.querySelectorAll('[data-cc-reveal]');
      children.forEach((child, index) => {
        child.style.setProperty('--cc-stagger-index', index);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Re-initialize on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', initScrollReveal);
})();
